import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import Tick from "../../Images/Tick.jpg";
import Cross from "../../Images/Cross.jpg";
import { CloudIcon } from "../../Svg/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { OrLineStyles } from "../../Styles/styles";
import QrScanner from "react-qr-scanner";
import jsQR from "jsqr";
import { notification } from "antd";
import CryptoJS from "crypto-js";
import { useVerifyBookingByQrMutation } from "../../Redux/apis/ApiSlice";
import { useVerifyTicketAuthenticationMutation } from "../../Redux/apis/ApiSlice";

const YOUR_SECRET_KEY = "Zeee@37104";

const QRCodeUpload = () => {
  const location = useLocation();
  const userData = localStorage.getItem("userData");
  const parsedData = JSON.parse(userData);
  const localId = parsedData.id;
  const { eventId, userId } = location.state || {}; // Fallback in case state is undefined
  const idToUse = userId ? userId : localId;
  console.log("idToUse", idToUse);
  const [eventIdAuth, setEventIdAuth] = useState(null);
  const [bookingIdAuth, setBookingIdAuth] = useState(null);
  const [ticketCodeAuth, setTicketCodeAuth] = useState(null);
  const [userIdAuth, setUserIdAuth] = useState(null);
  const [notMine, setNotMine] = useState(false);
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [scanResult, setScanResult] = useState(null);
  const [open, setOpen] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const baseURL = `${apiUrl}/ticket-info?`;
  const [verifyBookingByQr] = useVerifyBookingByQrMutation();
  const [verifyTicketAuthentication] = useVerifyTicketAuthenticationMutation();
  const [scanned, setScanned] = useState();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFile(file);
    scanQRCodeFromFile(file);
  };

  const encryptData = (text) => {
    return CryptoJS.AES.encrypt(text, YOUR_SECRET_KEY).toString();
  };

  const handleUploadClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragOver(false);
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      const file = event.dataTransfer.files[0];
      setFile(file);
      scanQRCodeFromFile(file);
    }
  };

  const scanQRCodeFromFile = async (file) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      const img = new Image();
      img.onload = async () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0, img.width, img.height);

        const imageData = context.getImageData(0, 0, img.width, img.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height);

        if (code) {
          const incomingData = code.data; // QR code content
          const encryptedData = encryptData(incomingData); // Encrypting the data
          const fullURL = `${baseURL}${encryptedData}`; // Building the full URL
          setScanResult(fullURL); // Set the scan result to the full URL

          const urlParams = new URLSearchParams(incomingData);
          const eventIdParams = urlParams.get("eventId");
          const ticketCodeParams = urlParams.get("ticketCode");
          const bookingIdPArams = urlParams.get("bookingId");
          const newTicketCode = Number(ticketCodeParams);
          setEventIdAuth(eventIdParams);
          setBookingIdAuth(bookingIdPArams);
          setUserIdAuth(userId);
          setTicketCodeAuth(newTicketCode);
          try {
            const ticketVerification = await verifyTicketAuthentication(
              newTicketCode
            );
            setScanned(ticketVerification.data.scanned);
          } catch (error) {
            console.log("Error in ticketVerification", error.scanned);
          }
          if (eventIdParams && bookingIdPArams && eventIdParams == eventId) {
            setOpen(true);
            setNotMine(false);
          } else {
            setNotMine(true);
            setOpen(true);
            notification.error({
              message: "QR doesn't belong to this event!",
            });
          }
        } else {
          setScanResult("No QR code found.");
          setOpen(true);
        }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
    // Clear file input after reading
    document.getElementById("fileInput").value = null;
  };

  const handleScanComplete = async () => {
    try {
      const response = await verifyBookingByQr({
        eventId: Number(eventIdAuth),
        userId: Number(idToUse),
        bookingId: Number(bookingIdAuth),
        ticketCode: Number(ticketCodeAuth),
      }).unwrap();
      setScanned(true);
      notification.success({ message: "Verification successful!" });
      // Show the result modal or popup only on success
    } catch (err) {
      console.error("Verification failed:", err);
      setScanned(true);
      notification.error({
        message: err?.data?.error || "You can't scan this QR!",
      });
    }
  };

  const handleScan = async (data) => {
    if (data) {
      const incomingData = data.text;
      const encryptedData = encryptData(incomingData);
      const fullURL = `${baseURL}${encryptedData}`;
      setScanResult(fullURL);
      console.log("Full URL:", fullURL);

      const urlParams = new URLSearchParams(incomingData);
      const eventIdParams = urlParams.get("eventId");
      const ticketCodeParams = urlParams.get("ticketCode");
      const bookingIdPArams = urlParams.get("bookingId");
      const newTicketCode = Number(ticketCodeParams);
      setEventIdAuth(eventIdParams);
      setBookingIdAuth(bookingIdPArams);
      setUserIdAuth(userId);
      setTicketCodeAuth(newTicketCode);

      // Only proceed if we have valid eventId and bookingId, and they match
      // if (eventIdParams && bookingIdParams && eventIdParams == eventId) {
      setOpen(true);
      toggleScanner();
      setTimeout(() => {
        setShowScanner(true);
      }, 500);
      // } else {
      //   notification.error({
      //     message: "You can't scan this QR!",
      //   });
      // }
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCopy = () => {
    if (scanResult) {
      navigator.clipboard
        .writeText(scanResult)
        .then(() => {
          notification.success({
            message: "Link copied to clipboard!",
          });
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };

  const toggleScanner = () => {
    setShowScanner(!showScanner);
  };

  const displayLink = scanResult ? scanResult.split("?")[0] + "..." : ""; // Show initial part of the link

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // minHeight: "93vh",
        background: "linear-gradient(to bottom, #e7ecf4, #ffffff)",
        px: 2,
      }}
    >
      {/* Card Container */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 3,
          mt: 6,
        }}
      >
        {/* Alphanumeric Code Card */}
        <Box
          onClick={() =>
            navigate("/verify-code", { state: { eventId, userId: idToUse } })
          }
          sx={{
            width: 280,
            p: 3,
            bgcolor: "purple",
            borderRadius: 4,
            color: "#fff",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            position: "relative",
            overflow: "hidden",
            "&:hover": {
              transform: "translateY(-6px)",
              boxShadow: "0 14px 36px rgba(0,0,0,0.2)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: -20,
              right: -20,
              width: 60,
              height: 60,
              backgroundColor: "#fff3",
              borderRadius: "50%",
              animation: "pulse 2s infinite ease-in-out",
            },
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            🔠 Verify with Code
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.85 }}>
            Please enter the alphanumeric code printed on your ticket to verify
            your ticket.
          </Typography>
        </Box>

        {/* Name Card */}
        <Box
          onClick={() =>
            navigate("/verify-name", { state: { eventId, userId: idToUse } })
          }
          sx={{
            width: 280,
            p: 3,
            bgcolor: "green",
            borderRadius: 4,
            color: "#fff",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            position: "relative",
            overflow: "hidden",
            "&:hover": {
              transform: "translateY(-6px)",
              boxShadow: "0 14px 36px rgba(0,0,0,0.2)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              bottom: -20,
              left: -20,
              width: 60,
              height: 60,
              backgroundColor: "#fff3",
              borderRadius: "50%",
              animation: "pulse 2.5s infinite ease-in-out",
            },
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            🧑 Verify with Name
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.85 }}>
          Enter the full name as printed on your ticket to search and verify your ticket.
          </Typography>
        </Box>

        {/* QR Code Card */}
        <Box
          onClick={toggleScanner}
          sx={{
            width: 280,
            p: 3,
            bgcolor: "#132B52",
            borderRadius: 4,
            color: "#fff",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            position: "relative",
            overflow: "hidden",
            "&:hover": {
              transform: "translateY(-6px)",
              boxShadow: "0 14px 36px rgba(0,0,0,0.2)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: -15,
              left: -15,
              width: 60,
              height: 60,
              backgroundColor: "#fff3",
              borderRadius: "50%",
              animation: "pulse 3s infinite ease-in-out",
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              mb: 1,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <QrCodeScannerIcon /> Scan QR Code
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.85 }}>
          Scan the QR code printed on your ticket using your camera to verify instantly.
          </Typography>
        </Box>
      </Box>

      {/* QR Scanner Placement */}
      {showScanner && (
        <Box
          sx={{
            mt: 6,
            width: "100%",
            maxWidth: 420,
            bgcolor: "#ffffff",
            p: 2,
            borderRadius: 3,
            boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          }}
        >
          <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>
            QR Scanner
          </Typography>
          <QrScanner
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: "100%", borderRadius: 8 }}
          />
        </Box>
      )}
      {open && (
        <Box>
          <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
            Scan Result
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 2,
                borderRadius: 2,
                bgcolor: scanned ? "white" : "white",
              }}
            >
              <img
                width={100}
                height={100}
                src={notMine ? Cross : Tick}
                alt=""
              />
              <Typography variant="subtitle1" fontWeight={600}>
                {notMine
                  ? "This is not your Event QR"
                  : scanned
                  ? "Already Authenticated"
                  : "Not Authenticated Yet"}
              </Typography>
            </Box>
          </DialogContent>

          {!notMine && (
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
              <Button onClick={handleCopy} variant="contained" color="primary">
                Copy Link
              </Button>
              <Button
                onClick={() => window.open(scanResult, "_blank")}
                variant="contained"
                color="secondary"
                disabled={!scanResult}
              >
                Open
              </Button>
              {!scanned && (
                <Button
                  onClick={handleScanComplete}
                  variant="outlined"
                  color="inherit"
                >
                  Authenticate
                </Button>
              )}
            </DialogActions>
          )}
        </Box>
      )}

      {/* Keyframe Animation for Pulse */}
      <style>{`
    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 0.6;
      }
      50% {
        transform: scale(1.3);
        opacity: 0.3;
      }
      100% {
        transform: scale(1);
        opacity: 0.6;
      }
    }
  `}</style>
    </Box>
  );
};

export default QRCodeUpload;
